/**
 * BusinessSection — «للشركات»: copy + points, and the approved company dashboard
 * (browser frame ≥761px, phone frame ≤760px) with Sara's pass over its edge.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Analytics01Icon, Building06Icon, DashboardSquare01Icon, LockKeyIcon, UserGroupIcon } from '@hugeicons/core-free-icons';
import Icon from '../../components/v2/Icon.jsx';
import { useStr } from './useStr.js';
import { SARA, SARA_PHOTO_URL } from './data.js';
import PassSlot from './PassSlot.jsx';
import dashboardOverview from './assets/dashboard-overview.jpg';
import overviewMobile from './assets/overview-mobile.png';

const POINTS = [
  { icon: UserGroupIcon, t: 'pt1T', d: 'pt1D' },
  { icon: DashboardSquare01Icon, t: 'pt2T', d: 'pt2D' },
  { icon: Analytics01Icon, t: 'pt3T', d: 'pt3D' }
];

export default function BusinessSection() {
  const { t, ar, arrow } = useStr();
  return (
    <section className="sx">
      <div className="wrap">
        <div className="pg biz" id="business">
          <div className="bhd">
            <div className="tx">
              <div className="eb"><Icon icon={Building06Icon} />{t('bizEb')}</div>
              <h2>{t('bizTitle')}</h2>
              <p>
                {ar
                  ? <>حوّل بطاقات شركتك إلى أصول رقمية تتحدّث ذاتيًا، تجمع لك العملاء المحتملين، وتعيش في <span className="nw">Apple Wallet و Google Wallet</span>.</>
                  : <>Turn your company’s cards into self-updating digital assets that collect leads for you and live in <span className="nw">Apple Wallet</span> and <span className="nw">Google Wallet</span>.</>}
              </p>
              <Link className="btn dark lg" to="/business">{t('bizCta')}<Icon icon={arrow} /></Link>
            </div>
            <div className="pts">
              {POINTS.map((p) => (
                <div className="pt" key={p.t}>
                  <Icon icon={p.icon} />
                  <div><b>{t(p.t)}</b><span>{t(p.d)}</span></div>
                </div>
              ))}
            </div>
          </div>
          <div className="bvz">
            <div className="browser">
              <div className="bbar" aria-hidden="true">
                <i /><i /><i />
                <span className="url"><Icon icon={LockKeyIcon} />business.cardpass.co</span>
              </div>
              <div className="bimg"><img src={dashboardOverview} alt={t('bizImg')} loading="lazy" width="1600" height="1000" /></div>
            </div>
            <div className="bphone">
              <div className="scr"><img src={overviewMobile} alt={t('bizImgM')} loading="lazy" width="780" height="1688" /></div>
            </div>
            <PassSlot className="sara" card={SARA} photoUrl={SARA_PHOTO_URL} scale={0.62} scaleT={0.55} scaleM={0.5} />
          </div>
        </div>
      </div>
    </section>
  );
}
